import React, { useEffect, useState } from "react";
import useAxiosPrivate from "../../../../../hooks/useAxiosPrivate";
import BigCalendar from "../../../../BigCalendar/BigCalendar";
import moment from "moment";
import statusColor from "../../../../../utils/Attendance/statusColor";
import attendaceStatus from "../../../../../utils/Attendance/attendanceStatus";
import { extractClockInOutTimes } from "../../../../../utils/Attendance/extractClockInOutTimes";

const MyAttendanceCalendarView = ({
  selectedOption,
  label,
  fromDate,
  toDate,
}) => {
  const [calendarData, setCalendarData] = useState([]);
  const axiosPrivate = useAxiosPrivate();

  const fetchAttendanceData = async () => {
    try {
      const response = await axiosPrivate.get(
        `/attendance/getListOfClockInAndClockOut`,
        {
          params: {
            label: label?.value,
            selectedOption: selectedOption?.value,
            from_date: fromDate,
            to_date: toDate,
          },
        }
      );

      if (response?.data?.data) {
        const formattedData = response.data.data.map((event) => {
          const { firstClockIn, lastClockOut } =
            extractClockInOutTimes(event.activity, event.shiftDuration);

          const statusLabel =
            attendaceStatus.find(
              (status) => status.value === event.attendance_status_id
            )?.label || "-";

          return {
            title: (
              <div className="text-xs leading-4">
                <div className="font-semibold">{statusLabel}</div>
                <div>
                  First Clock In:  {firstClockIn} 
                </div>
                <div>  Last Clock In: {lastClockOut} </div>
              </div>
            ),
            start: moment(event.attendance_date).toDate(),
            end: moment(event.attendance_date).toDate(),
          };
        });

        setCalendarData(formattedData);
      } else {
        setCalendarData([]);
      }
    } catch (error) {
      console.error("Error fetching attendance data:", error);
      setCalendarData([]);
    }
  };

  useEffect(() => {
    fetchAttendanceData();
  }, [fromDate, toDate, selectedOption, label]);

  return (
    <div className="p-5">
      <BigCalendar myEventsList={calendarData} />
    </div>
  );
};

export default MyAttendanceCalendarView;
